import styled from 'styled-components';
import tsfont from '../../../tsfont.json';
import { minWidth } from 'helpers/buildMediaQueries';
import {
  fontVariables,
  gutterVariables,
  colorsVariables,
  flexItemsCentered
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { TextOverflowEllipsis } from 'styles/utils/text.styles';

export const ShopResultListHeader = styled.div`
  padding: 0 ${gutterVariables.GUTTER};
  text-align: center;
  line-height: ${fontVariables.LINE_HEIGHT_L};
  position: relative;
  grid-area: 2 / 1 / 3 / 2;
  ${minWidth('sm', 'grid-area: 2 / 2 / 2 / 4; padding: 0;')};
  ${minWidth(
    'xl',
    `grid-area: 2 / 3 / 3 / 3; margin-left: ${gutterVariables.GUTTER_HALF}; margin-top: 10px;`
  )};

  h2 {
    font-size: ${fontVariables.SIZE_TEXT};
    font-weight: ${fontVariables.FONT_WEIGHT_REGULAR};
    line-height: ${fontVariables.LINE_HEIGHT_L};
    margin-bottom: ${gutterVariables.GUTTER_HALF};

    ${minWidth(
      'xl',
      `
      font-weight: ${fontVariables.FONT_WEIGHT_BOLD};
      font-size: 20px;
      display: flex;
      white-space: nowrap;
      justify-content: center;
    `
    )};

    ${minWidth(
      'xl',
      `
      margin-bottom: ${gutterVariables.GUTTER_HALF};
    `
    )};

    .for-number-results-text {
      display: none;
      white-space: nowrap;
      font-weight: ${fontVariables.FONT_WEIGHT_REGULAR};
      ${minWidth('xl', 'display: inline-flex;')};
      & > * {
        min-width: 0;
        flex: 1 0 auto;
      }
    }

    .for-query-results-text {
      flex: 0 1 auto;
      min-width: 0;
      font-weight: ${fontVariables.FONT_WEIGHT_REGULAR};
      display: none;
      ${minWidth('xl', 'display: inline-flex;')};

      strong {
        flex: 0 1 auto;
        min-width: 0;
        display: inline-block;
        ${TextOverflowEllipsis};
      }
    }
  }

  .for-query-text {
    font-size: 20px;
    font-weight: ${fontVariables.FONT_WEIGHT_MEDIUM};
    ${minWidth('xl', 'display: none;')}
  }

  ${tsfont.templateOptions.baseSelector}${tsfont.templateOptions
    .baseSelector}-icon-action-dismiss {
    position: absolute;
    top: 0;
    right: ${gutterVariables.GUTTER};
    cursor: pointer;
    ${minWidth('xl', 'display: none;')}
  }

  hr {
    border: 0;
    border-top: 1px solid ${colorsVariables.GRAY_200};
    margin: ${gutterVariables.GUTTER_HALF} 0;
  }

  .filters-sorting {
    ${minWidth(
      'xl',
      `
      ${flexItemsCentered};
      justify-content: space-between;
    `
    )};

    hr {
      ${minWidth('xl', 'display: none;')}
    }
  }
`;
